"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect = void 0;
/**
 * Outcomes of policy decisions.
 *
 * @public
 */
var Effect;
(function (Effect) {
    /**
     * The action should be allowed.
     */
    Effect["ALLOW"] = "EFFECT_ALLOW";
    /**
     * The action should be denied.
     */
    Effect["DENY"] = "EFFECT_DENY";
})(Effect || (exports.Effect = Effect = {}));
//# sourceMappingURL=Effect.js.map